<mat-spinner style="position:fixed;top:50%;left:50%" *ngIf="!load"></mat-spinner>

<div class="lti-login" *ngIf="load">

  <!-- Left: marketing panel -->
  <aside class="lti-login-left">
    <div class="lti-login-left-inner">

      <div class="lti-login-logo">
        <img src="assets/images/LTI-logo-white-v2.png" alt="LetsTimeIt" class="lti-brand-logo">

      </div>

      <div class="lti-login-hero">
        <h1>Keep every session<br/>on&nbsp;time.</h1>
        <p>The control surface for stage managers at conferences, events, and live productions worldwide.</p>
      </div>

      <div class="lti-demo-card">
        <div class="lti-demo-head">
          <div class="lti-chip-live"><span class="lti-chip-dot"></span> LIVE</div>
          <span class="lti-demo-label">Main Stage · Keynote</span>
        </div>
        <div class="lti-demo-time">09:24</div>
        <div class="lti-demo-bar"><div></div></div>
      </div>

      <div class="lti-features">
        <div class="lti-feature">
          <div class="lti-feature-icon"><mat-icon>bolt</mat-icon></div>
          <div>
            <div class="lti-feature-title">Sub-frame accuracy</div>
            <div class="lti-feature-desc">Network-synced timers stay locked across every venue screen.</div>
          </div>
        </div>
        <div class="lti-feature">
          <div class="lti-feature-icon"><mat-icon>public</mat-icon></div>
          <div>
            <div class="lti-feature-title">Anywhere control</div>
            <div class="lti-feature-desc">Drive the room from a laptop, tablet, or phone — over the open web.</div>
          </div>
        </div>
        <div class="lti-feature">
          <div class="lti-feature-icon"><mat-icon>shield</mat-icon></div>
          <div>
            <div class="lti-feature-title">Built for live stakes</div>
            <div class="lti-feature-desc">Two-tap blackout, instant flash, kill-switch overrides.</div>
          </div>
        </div>
      </div>

      <div class="lti-login-footer">
        <span>© 2026 LetsTimeIt Inc.</span>
      </div>

    </div>
  </aside>

  <!-- Right: form panel -->
  <main class="lti-login-right">
    <form class="lti-login-form-wrap" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <h2 class="lti-form-title">Welcome back</h2>
      <p class="lti-form-sub">Sign in to your operator console.</p>

      <div class="lti-social-stack">
        <div class="lti-google-btn-wrap">
          <asl-google-signin-button type='standard' logo_alignment="left" shape="rectangular"
            size='large' text="signin_with" theme="outline" width="356"></asl-google-signin-button>
        </div>
        <a href="javascript:void(0)" (click)="signInWithMicrosoft()" class="lti-social-btn">
          <img src="https://panel.letscalendar.com/assets/images/icon-MS.svg" alt="Microsoft" width="16" />
          Continue with Microsoft
        </a>
      </div>

      <div class="lti-divider"><span>or continue with</span></div>

      <div class="lti-form-stack">
        <div>
          <label class="lti-field-label">Email</label>
          <mat-form-field class="w-100">
            <input type="email" formControlName="email" [maxlength]="150"
              matInput placeholder="you@company.com" />
            @if (frmCtrl.email.invalid) {
              <mat-error>{{errorMessage.email??''}}</mat-error>
            }
          </mat-form-field>
        </div>
        <div>
          <div class="lti-field-header">
            <label class="lti-field-label">Password</label>
            <a routerLink="/forgot-password" class="lti-link-sm">Forgot password?</a>
          </div>
          <mat-form-field class="w-100">
            <input type="password" [maxlength]="100" [minlength]="8" formControlName="password"
              matInput placeholder="••••••••••" />
            @if (frmCtrl.password.invalid) {
              <mat-error>{{errorMessage.password??''}}</mat-error>
            }
          </mat-form-field>
          <mat-error class="errMsg" *ngIf="error">{{error}}</mat-error>
        </div>
        <button class="lti-submit-btn" type="submit" [disabled]="!submitable">
          <mat-spinner *ngIf="processing" [diameter]="20"
            style="--mdc-circular-progress-active-indicator-color:#ffffff" class="mx-auto"></mat-spinner>
          <span *ngIf="!processing">Sign in</span>
        </button>
      </div>

      <p class="lti-register-hint">
        Don't have an account? <a routerLink="/register" class="lti-link">Create one</a>
      </p>
    </form>
  </main>

</div>
